import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`


  /* 🌎 글로벌 변수 설정 */
  :root {
    /* max-width: 1440px;
    margin: 0 auto;
    padding: 2rem; */
    text-align: center;
    --gray-ui-gray01: #191919;
    --button-line-line01: #bfc5cc;
    --primary-white: #fff;

    
  }

  /* 🌎 기본 스타일 리셋 */
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  html {
    font-family: "Spoqa Han Sans Neo", sans-serif;
    overflow-x: hidden;
  }

  /* 🌎 전체 페이지 스타일 */
  body {
    width: 100vw;
    height: 100%;
    margin: 0;
    padding: 0;
    overflow-x: hidden;
    color: #333;
    background-color: var(--primary-white);
    overflow-x: hidden; /* 가로 스크롤 방지 */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-text-size-adjust: 100%;
    
  }

  button {
    cursor: pointer;
    transition: all 0.2s ease-in-out; /* 모든 애니메이션 효과 적용 */
    border: none; 
    background: transparent; /* ✅ 기본 배경을 투명하게 설정 */
    text-decoration: none;
  }

  button:active {
    transform: scale(0.95); /* 버튼을 누를 때 살짝 작아지는 효과 */
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2); /* 눌린 느낌을 위한 그림자 효과 */
  }

    /* 🌎 숫자 인풋 스핀 버튼 제거 */
    input[type="number"]::-webkit-outer-spin-button,
  input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type="number"] {
    -moz-appearance: textfield; /* Firefox */
    appearance: textfield;
  }

  p {
    margin: 0;
  }

`;

export default GlobalStyles;
